import { AdditionalFormNames, IAdditionalFormDefinition } from '../../models/form/IFormDefinition'
import { correspondenceAddressInfoFields, correspondenceAddressInfoFieldValidations } from './CorrespondenceAddressInfoFields'

export const correspondenceAdressInfoForm: IAdditionalFormDefinition = {
   name: AdditionalFormNames.CorrespondenceAddressForm, 
   additionalFields: correspondenceAddressInfoFields,
   label: "Adres korespondecyjny",
   switchLabel: 'Adres korespondenycjny inny niż zamieszkania',
   formValidationFunctions: correspondenceAddressInfoFieldValidations,
}